import Rest from '../../app/Base/Rest';

/**
 * @typedef {UserPermissionService}
 */
export default class UserPermissionService extends Rest {
	/**
	 * @type {String}
	 */
	static resource = '/userpermission';

}
